import React from "react";
import {inject} from "mt-react-decorators";
import {Provider} from "mobx-react";
import SectionAverage from "widgets/mtt-sustainability-tool/js/SectionAverage";

@inject(['manager'])
export default class DataBlock extends React.Component {

    get manager(){
        return this.props.manager;
    }

    get section(){
        return this.props.section;
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__table'}>
                <Provider data_section={this.section}>
                    <React.Fragment>
                        {this.props.children}
                    </React.Fragment>
                </Provider>
                <SectionAverage section={this.section}/>
            </div>
        );
    }
}